export const menuItems = [
    { title: "Главная", link: "/main" },
    {
        title: "Программы",
        link: "/treatment",
        submenu: [
            {
                title: "Процедуры",
                link: "/treatment",
                submenu: [
                    { title: "Грязелечение", link: "/treatment" },
                    { title: "Аэрогидромассаж", link: "/treatment" },
                    { title: "Криотерапия", link: "/treatment" },
                    { title: "Ударно-волновая терапия", link: "/treatment" },
                    { title: "Ванна сухая углекислая", link: "/treatment" },
                    { title: "Подводный душ массаж", link: "/treatment" },
                    { title: 'Минеральные ванны', link: "/treatment" },
                    { title: 'Массаж в санатории', link: "/treatment" },
                    { title: 'Солодковые ванны', link: "/treatment" },
                    { title: 'Cпелеотерапия', link: "/treatment" },
                ]
            },
            {
                title: "Специальные программы",
                link: "/treatment",
                submenu: [
                    { title: "Снижение веса", link: "/treatment" },
                    { title: "Урология", link: "/treatment" },
                    { title: "Гинекология", link: "/treatment" },
                    { title: "Антистресс", link: "/treatment" },
                    { title: "Лечебное плавание", link: "/treatment" }
                ]
            },
        ]
    },
    {
        title: "Номера",
        link: "/rooms",
    },
    {
        title: "Услуги",
        link: "/food",
        submenu: [
            { title: "Досуг", link: "/food" },
            { title: "Инфраструктура", link: "/food" }
        ]
    },
    {title: "Информация",link: "/info",}
];